'use client';

import { useEffect } from 'react';

import './globals.css';
import '@mokoboko/components/styles';
import { CrashState } from '@/components/page-states';
import { captureError } from '@/lib/capture-error';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// Catches crashes in the root layout itself — the outermost error boundary.
// Must include its own <html>/<body> since the layout is broken, and the
// stylesheets the layout would have loaded.
export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    // ChunkLoadError means the user has a stale tab open after a deployment.
    // Auto-reload to fetch the new chunks instead of showing an error screen.
    if (error.name === 'ChunkLoadError') {
      window.location.reload();
      return;
    }

    captureError({
      error,
      source: 'global_crash',
      severity: 'fatal',
      context: { digest: error.digest },
    });
  }, [error]);

  return (
    <html lang="en">
      <body className="antialiased">
        <div className="flex min-h-screen items-center justify-center bg-olive-25 px-4 py-16">
          <CrashState onRetry={reset} />
        </div>
      </body>
    </html>
  );
}
